import { render, staticRenderFns } from "./LoadingTemplate.vue?vue&type=template&id=7b9f27c6&"
import script from "./LoadingTemplate.vue?vue&type=script&lang=ts&"
export * from "./LoadingTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports